import { Box, Divider, Grid, InputAdornment, TableSortLabel } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

//component
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import CommissionList from './commissionList'
import CommissionSummary from './commissionSummary'
//utils
import { getBranch, isBuddhistYear, toBuddhistYear } from 'utils/app.utils'
import { UseSnCode } from 'utils/useSnCode'
/** STYLE */
import { colors } from 'constants/theme'
import * as UseStyled from 'features/report/useStyled'

//API
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DoctorScheduleApi from 'api/counter/doctor-schedule.api'
import ClinicApi, { DentistInterface } from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import OperativeApi from 'api/setting/treatments/operative.api'
import Loading from 'component/Loading'
import TableRowExport from 'component/Pdf/TableRowExport'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import TextInput from 'new-components/inputs/text-input'
import { ExportProps } from '../report-constants'
type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

export default function Commission() {
  const { t } = useTranslation()
  const history = useHistory()
  const momentDate = () => [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]

  const componentRef = useRef<HTMLDivElement>(null)
  const [branches, setBranches] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  const [opertatives, setOperative] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [limit, setLimit] = useState<number>(10)

  const [search, setSearch] = useState<string>('')
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)

  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [selectDoctors, setSelectDoctors] = useState<any[]>([])
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])
  const [billPrefixId, setBillPrefixId] = useState(0)
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [commissionData, getCommissionData] = useState<any>({ rows: [] })
  const [commissionExportData, setCommissionExportData] = useState<any>({ rows: [] })
  const [rowCount, setRowCount] = useState<number>(0)

  const [operativeId, setOperativeId] = useState<any>(0)
  const [fetch, setFetch] = useState<boolean>(false)

  const [snType, setSnType] = useState<boolean>(false)

  const filterSelectOperativeName = useRef<HTMLDivElement>(null)
  const [filterSelectOperativeNameWidth, setFilterSelectOperativeNameWidth] = useState<number>(0)
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  useEffect(() => {
    if (filterSelectOperativeName.current) {
      const width: any = filterSelectOperativeName.current.clientWidth

      setFilterSelectOperativeNameWidth(width)
    }
  }, [filterSelectOperativeName.current, filterSelectOperativeName?.current?.clientWidth])
  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }
  const handleFilterDoctors = (value: any) => {
    if ((value === 'ALL' && _.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)) || value === 'CLEAR') setSelectDoctors([''])
    else if (value === 'ALL') setSelectDoctors([..._.map(doctors, (d: any) => d.userId)])
    else if (_.includes(selectDoctors, value)) setSelectDoctors(_.filter(selectDoctors, (d) => d !== value))
    else setSelectDoctors([...selectDoctors, value])
  }

  const getAllFilter = () => {
    return [
      {
        label: t('REPORT.FILTER.BRANCH'),
        value: _.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')
      },
      {
        label: t('REPORT.FILTER.RECEIPT_TYPE'),
        value: billPrefixId ? receiptPrefix.find((item) => item.billPrefixId === billPrefixId).prefix : t('REPORT.REPORT_GROUP.ALL')
      },
      {
        label: t('REPORT.FILTER.DATE_START'),
        value: rangeDate[0] ? toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY') : '-'
      },
      {
        label: t('REPORT.FILTER.DATE_END'),
        value: rangeDate[1] ? toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY') : '-'
      },
      {
        label: t('REPORT.FILTER.DOCTOR_SALE'),
        value: _.isEmpty(selectDoctors)
          ? ` ${t('REPORT.FILTER.NO_SELECT')}`
          : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
            ? `${t('REPORT.FILTER.ALL')}`
            : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
              ?.map((d: any) => d.fullname)
              .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
              .join(', ')}`
      },
      {
        label: t('REPORT.FILTER.OPERATIVE_PRODUCT'),
        value: operativeId ? operativeId.operativeName : t('REPORT.REPORT_GROUP.ALL')
      }
    ]
  }
  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.COMMISSION`)} (${rangeDate[0]}-${rangeDate[1]})`,
    sheetName: `${t(`REPORT.REPORT_NAME.COMMISSION`)}`
  })

  // พิมพ์ PDF ด้วย window.print() บน document หลัก (iframe ปริ้นไม่ได้บน iOS Safari)
  // เนื้อหาที่จะพิมพ์อยู่ใน Box#print-table-container ซึ่ง CSS @media print จัดการ ซ่อน/แสดง
  const handlePrintPdf = () => {
    const STYLE_ID = 'commission-print-landscape'
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style')
      style.id = STYLE_ID
      style.innerHTML = '@media print { @page { size: landscape; } }'
      document.head.appendChild(style)
    }
    const cleanup = () => {
      document.getElementById(STYLE_ID)?.remove()
      window.removeEventListener('afterprint', cleanup)
    }
    window.addEventListener('afterprint', cleanup)
    window.print()
  }

  const loadCommissionExport = useCallback(async () => {
    let condition: any = {
      page: 1,
      pageLimit: 1000,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      export: 1
    }
    if (doctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, userId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }

    if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }

    if (billPrefixId) condition = { ...condition, paymentTypeId: receiptPrefix.find((item) => item.billPrefixId === billPrefixId).prefix }
    if (operativeId?.operativeId) condition = { ...condition, operativeId: operativeId.operativeId }
    if (search) {
      condition = condition = { ...condition, search: search }
    }

    ReportApi.reportCommission(condition)
      .then(({ data }) => {
        setCommissionExportData(data)
      })
      .catch((e) => setLoading(false))
      .finally(() => {
        setLoading(false)
        setFetch(false)
      })
  }, [page, limit, fetch, doctors])

  const fetchCommission = useCallback(() => {
    setLoading(true)
    let condition: any = {
      page: page,
      pageLimit: limit,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1]
    }
    if (search) {
      condition = condition = { ...condition, search: search }
    }
    if (doctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, userId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }

    if (rangeDate) {
      if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }
    if (billPrefixId) condition = { ...condition, paymentTypeId: receiptPrefix.find((item) => item.billPrefixId === billPrefixId).prefix }
    if (operativeId?.operativeId) condition = { ...condition, operativeId: operativeId.operativeId }

    ReportApi.reportCommission(condition)
      .then(({ headers, data }) => {
        getCommissionData(data)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => {
        setLoading(false)
        setFetch(false)
      })
  }, [page, limit, fetch, doctors])

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'COMMISSION') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })
    /** MASTER DATA */
    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data: dataAllDoctor }) => {
      const dentists: DentistInterface[] = dataAllDoctor.map((d: any) => {
        return {
          dentistId: d.userId,
          dentistFullname: d.fullname
        }
      })
      setDoctorsMultiple(dentists)
      setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
    })

    OperativeApi.findAll({ export: 1 })
      .then(({ data }) => {
        setOperative([{ operativeName: t('REPORT.REPORT_GROUP.ALL'), operativeId: 0 }, ...data])
      })
      .catch((e) => {
        return
      })

    ClinicApi.allBillPrefix()
      .then((resp) => setReceiptPrefix([{ billPrefixId: 0, prefix: t('REPORT.REPORT_GROUP.ALL') }, ...resp.data]))
      .catch((e) => {
        return
      })

    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
      .then((resp) => {
        setDoctors([...resp.data])
      })
      .catch((e) => {
        return
      })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [])

  useEffect(() => {
    fetchCommission()
  }, [fetchCommission])

  useEffect(() => {
    loadCommissionExport()
  }, [loadCommissionExport])

  const handleChangeRowsPerPage = (limit: number) => {
    setLimit(limit)
  }
  const handleChangePage = (val: number) => setPage(val)
  const onRequestSort = () => {
    // setSortType(sortTypeVal)
    // setSortBy(sortByVal)
  }

  const headCells = [
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.#NO', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.BILL_ID', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.DATETIME', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.USER_NAME', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.CN', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.SN', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.PATIENT_NAME', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.LIST', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.PRICE', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.QTY', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.TOTAL', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.PAID', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.COMMISSION', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.REMARK', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.COMMISSION.CREATEDBY', align: 'center', class: 'text-nowrap' }
  ]

  if (!snType) {
    headCells.splice(5, 1)
  }

  const renderCommissionExport = (data: any, no = 1) => {
    const num = no + 1
    const columns = [
      { option: 'TEXT', align: 'center', label: num },
      { option: 'TEXT', align: 'left', label: data.paymentNumber },
      { option: 'TEXT', align: 'left', label: moment(data.dataTime).add(isBuddhistYear(), 'y').format('DD/MM/YYYY HH:mm น.') },
      { option: 'TEXT', align: 'left', label: data.userFullName },
      { option: 'TEXT', align: 'center', label: data.cnNumber },
      { option: 'TEXT', align: 'center', label: data.snCode },
      { option: 'TEXT', align: 'left', label: data.patientFullName },
      { option: 'TEXT', align: 'left', label: data.list },
      { option: 'TEXT', align: 'right', label: data.price },
      { option: 'TEXT', align: 'center', label: data.qty },
      { option: 'TEXT', align: 'right', label: data.total },
      { option: 'TEXT', align: 'right', label: data.amountPaid },
      { option: 'TEXT', align: 'right', label: data.commission },
      { option: 'TEXT', align: 'left', label: data.remark },
      { option: 'TEXT', align: 'left', label: data.createdBy }
    ]
    if (!snType) {
      columns.splice(5, 1)
    }
    return (
      <>
        <TableRowExport key={num.toString()} id={no.toString()} obj={data} columns={columns} />
      </>
    )
  }

  return (
    <Box className={'border-0 h-100'}>
      <HeaderCard text={t(`REPORT.REPORT_NAME.COMMISSION`)} />
      <Box padding="16px">
        <Grid container spacing="8px">
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <TextInput
              onChange={(e) => setSearch(e.target.value)}
              fullWidth
              label={t('REPORT.REPORT_NAME.SEARCH_COMMISSION')}
              value={search}
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <SelectInput
              label={t('REPORT.FILTER.BRANCH')}
              value={branchId}
              onChange={e => {
                setBranchId(Number(e.target.value));
              }}
              options={[
                ...branches.map(b => ({
                  value: b.branchId,
                  name: b.branchName || b.branchNameEn || ''
                }))]}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <SelectInput
              label={t('REPORT.FILTER.RECEIPT_TYPE')}
              value={billPrefixId}
              onChange={e => {
                setBillPrefixId(e.target.value)
              }}
              options={[
                ...receiptPrefix.map(b => ({
                  value: b.billPrefixId,
                  name: b.prefix
                }))]}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <SelectInput
              label={t('REPORT.FILTER.OPERATIVE_PRODUCT')}
              value={operativeId}
              onChange={e => {
                setOperativeId(e.target.value)
              }}
              options={[
                ...opertatives.map(b => ({
                  value: b.operativeId,
                  name: b.operativeName || b.operativeNameEn
                }))]}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <SelectCheckBoxInput
              label={t('USER_DOCTOR')}
              options={doctors.map((d: any) => ({
                id: d.userId,
                name: d.fullname
              }))}
              selected={selectDoctors}
              onChange={(ids: any) => {
                setSelectDoctors(ids)
                setOpenFilterDoctors(false)
              }}
              fullWidth
              width="100%"
            />
          </Grid>
          <Grid item xs={0} sm={0} md={0} lg={2}></Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
              }}
              label={''}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={1} lg={1}>
            <MainButton
              onClick={() => {
                setFetch(true)
                setPage(1)
                setLoading(true)
              }}
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5} lg={9}>
            <UseStyled.DropdownDocument>
              <Dropdown.Toggle id="dropdown-basic" className="ml-xl-auto">
                {t('REGISTER.BUTTON.PRINT_DOCUMENT')}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={onDownload}>{t('Excel')}</Dropdown.Item>
                <Dropdown.Item onClick={handlePrintPdf}>{t('PDF')}</Dropdown.Item>
              </Dropdown.Menu>
            </UseStyled.DropdownDocument>
          </Grid>
        </Grid>

        <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
          <CommissionList page={page} pageLimit={limit} rowCount={rowCount} data={commissionData} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} onRequestSort={onRequestSort} />
        </Box>
        <Divider className="mx-0 mt-3 mb-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
        <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
          <CommissionSummary filterDate={rangeDate} page={page} pageLimit={limit} rowCount={rowCount} data={commissionData} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} onRequestSort={onRequestSort} />
        </Box>
      </Box>
      <Loading show={loading} type="fullLoading" />

      <Box id="print-table-container" ref={componentRef}>
        <ExportData
          componant={
            <>
              <span style={{ fontWeight: 'bold' }}>{t(`REPORT.REPORT_NAME.COMMISSION`)}</span>
              <table>
                <tr>
                  {getAllFilter().map((filter: any, index: number) => (
                    <TableSortLabel key={index}>
                      <td className="mr-2" style={{ textAlign: 'left', fontSize: 10, fontWeight: 800 }}>
                        {t(filter.label)} :{' '}
                      </td>
                      <td style={{ textAlign: 'left', fontSize: 10, fontWeight: 500 }}>{filter.value}</td>
                    </TableSortLabel>
                  ))}
                </tr>
              </table>
              <UseStyled.Styles className="pt-3">
                <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
                  <thead>
                    <tr>
                      {_.map(headCells, (val: any, index: number) => {
                        return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(commissionExportData.rows, (d: any, index: number) => {
                      return renderCommissionExport(d, index)
                    })}
                  </tbody>
                </table>
              </UseStyled.Styles>
            </>
          }
        />
      </Box>
    </Box>
  )
}

export function ExportData(props: ExportProps) {
  return <>{props.componant}</>
}
